export class MissingRequirementDto {
  Name: string;
  Status: string;
}
